module.exports = __webpack_public_path__ + "img/f6e53f6fc4dd00151f3fb8c1495c5598.gif";